import { Component, HostListener, OnInit } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

import { AccessibilityBarComponent } from '../../../common/accessibility-bar/accessibility-bar.component';
import { IUser } from '../../interfaces/global.interface';
import { GlobalService } from '../../services/global.service';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';

@Component({
  selector: 'app-standard-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    AccessibilityBarComponent,
    CommonModule,
    RouterModule,
    SidebarComponent,
  ],
  templateUrl: './standard-layout.component.html',
  styleUrls: ['./standard-layout.component.scss'],
})
export class StandardLayoutComponent implements OnInit {
  user!: IUser | null;
  opened = true;
  constructor(
    private router: Router,
    private globalService: GlobalService,
  ) {}

  ngOnInit() {
    this.setSidebarState();
    this.globalService.user$.subscribe((user) => {
      this.user = user;
    });
  }

  toggleSidebar() {
    const sidebar = document.querySelector('.sidebar');
    if (sidebar) {
      sidebar.classList.toggle('collapsed');
    }
  }

  logout() {
    sessionStorage.clear();
    this.router.navigate(['/auth']);
  }

  setSidebarState() {
    const sidebar = document.querySelector('.sidebar');
    if (sidebar) {
      if (window.innerWidth <= 768) {
        sidebar.classList.add('collapsed');
      } else {
        sidebar.classList.remove('collapsed');
      }
    }
  }
  @HostListener('window:resize', [])
  onResize() {
    this.setSidebarState();
  }
}
